/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { REPORT_JOB_COST_SUMMARY, REPORT_JOB_TRADING_ACCOUNT, ReportService } from '@gh/builder-shared';
import {
  DrawInvoiceStatus,
  InvoiceStatus,
  InvoiceType,
  JobFinancialsRestService,
  reportIdField
} from '@gh/builder-shared-data';
import { DictionaryService, getRouteParam, getRouteQueryParam, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { expandObservable } from '@gh/core-util';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import { JobFinancials, jobFinancialsFromDto } from './job-financials.model';

@Injectable()
export class JobFinancialsBusinessService implements InitViewService {
  constructor(private restService: JobFinancialsRestService,
              private reportService: ReportService,
              private dictionaryService: DictionaryService,
              private gridLayoutService: GridLayoutService) {
  }

  initView(route: ActivatedRouteSnapshot): any {
    const jobId = getRouteParam(route, 'jobId');
    return {
      jobFinancials: jobId ? this.get(jobId) : [],
      drawsLayout: this.gridLayoutService.get('jobFinancialsDraws'),
      paymentsLayout: this.gridLayoutService.get('jobFinancialsPayments'),
      expensesLayout: this.gridLayoutService.get('jobFinancialsExpenses'),
      invoiceTypes: this.dictionaryService.getByEnum(InvoiceType),
      invoiceStatuses: this.dictionaryService.getByEnum(DrawInvoiceStatus),
      reportUrls: jobId ? this.generateReportUrls(jobId) : {},
    };
  }

  get(jobId: ID): Observable<JobFinancials> {
    return this.restService.get(jobId).pipe(map$(jobFinancialsFromDto));
  }

  generateReportUrls(jobId: ID): Observable<{ jobTradingAccountReportUrl: string; jobCostSummaryReportUrl: string }> {
    return expandObservable({
      jobTradingAccountReportUrl: this.reportService.generateUrl(REPORT_JOB_TRADING_ACCOUNT, [
        reportIdField('Job', jobId),
      ]),
      jobCostSummaryReportUrl: this.reportService.generateUrl(REPORT_JOB_COST_SUMMARY, [
        reportIdField('Job', jobId),
      ]),
    });
  }
}
